module.exports = __webpack_public_path__ + "static/img/SK.20886a2f.svg";